export const getElevenLabsVoices = (response) => {
  if (Array.isArray(response?.voices)) {
    return response.voices;
  }

  if (!Array.isArray(response?.list)) {
    return [];
  }

  const elevenLabs = response.list.find(
    (provider) => provider?.modelProvider?.toLowerCase() === "11labs"
  );

  return Array.isArray(elevenLabs?.voices) ? elevenLabs.voices : [];
};
